import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Mail } from 'lucide-react';
export function HeroSection() {
  return <section className="bg-dark-100 text-text-dark py-16 md:py-24 px-6 overflow-hidden relative" data-id="element-45">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-3xl pointer-events-none" data-id="element-46"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col space-y-8 text-center lg:text-left order-2 lg:order-1" data-id="element-48">
          <div className="space-y-4" data-id="element-49">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.8
          }} className="inline-block px-4 py-1.5 rounded-full border border-accent/30 text-accent text-sm font-medium tracking-wide" data-id="element-50">
              Ebook + Guía Práctica
            </motion.div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight" data-id="element-51">
              S.O.S. Sueño Infantil: <br data-id="element-52" />
              <span className="text-accent italic" data-id="element-53">
                El Método de la Pausa Consciente
              </span>
            </h1>
          </div>

          <p className="text-lg md:text-xl text-text-dark/80 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-54">
            Recupera tu descanso y logra que tu bebé duerma su primer bloque de
            6 horas continuas en menos de 7 días{' '}
            <span className="font-semibold text-accent-subtle" data-id="element-55">
              (sin dejarlo llorar solo)
            </span>
            .
          </p>

          <div className="pt-4 flex flex-col items-center lg:items-start space-y-4" data-id="element-56">
            <motion.a href="#comprar" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="w-full sm:w-auto bg-accent text-dark-100 font-bold text-lg md:text-xl px-8 py-4 rounded-xl shadow-[0_0_30px_rgba(212,165,116,0.3)] hover:shadow-[0_0_40px_rgba(212,165,116,0.5)] transition-all duration-300 text-center" data-id="element-57">
              Quiero que mi bebé y yo durmamos hoy
            </motion.a>

            <div className="flex items-center justify-center lg:justify-start space-x-4 text-sm text-text-dark/60" data-id="element-58">
              <div className="flex items-center" data-id="element-59">
                <Lock className="w-4 h-4 mr-1.5" data-id="element-60" />
                <span data-id="element-61">Pago seguro</span>
              </div>
              <div className="w-1 h-1 rounded-full bg-text-dark/30" data-id="element-62"></div>
              <div className="flex items-center" data-id="element-63">
                <Mail className="w-4 h-4 mr-1.5" data-id="element-64" />
                <span data-id="element-65">Entrega inmediata</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="order-1 lg:order-2 flex justify-center lg:justify-end" data-id="element-66">
          <div className="relative" data-id="element-67">
            <div className="absolute inset-0 bg-accent/20 blur-2xl rounded-full transform scale-90" data-id="element-68"></div>
            <img src="https://cdn.magicpatterns.com/uploads/cNHuGfGcH3zo1JGgjs92g8/producto_2_nuevo_mejorado.png" alt="S.O.S. Sueño Infantil Ebook" className="relative z-10 w-full max-w-md rounded-2xl shadow-2xl border border-accent/10" data-id="element-69" />
          </div>
        </motion.div>
      </div>
    </section>;
}